import { PROGRAMS } from "../data/content";
import { SectionHeader } from "./SectionHeader";
import { Reveal } from "./Reveal";

export const MainPrograms = () => (
    <section
        id="program"
        data-testid="program-section"
        aria-labelledby="program-title"
        className="bg-bh-offwhite py-24 sm:py-32 scroll-mt-20"
    >
        <div className="max-w-[1565px] mx-auto">
            <SectionHeader
                eyebrow={PROGRAMS.eyebrow}
                title={PROGRAMS.title}
                sub={PROGRAMS.subtitle}
                testid="program-title"
            />
            <div className="px-6 sm:px-8 space-y-6 max-w-6xl mx-auto">
                {PROGRAMS.items.map((program, i) => {
                    const featured = program.key === "tahfidz";
                    return (
                        <Reveal key={program.key} delay={i * 0.1}>
                            <article
                                data-testid={`program-card-${program.key}`}
                                className={`relative rounded-3xl p-8 sm:p-12 grid md:grid-cols-12 gap-6 md:gap-10 items-start overflow-hidden transition-transform duration-300 hover:-translate-y-1 ${
                                    featured
                                        ? "bg-bh-deep text-white shadow-[0_24px_60px_rgba(6,76,61,0.3)]"
                                        : "bg-white border border-bh-green/12 shadow-[0_12px_36px_rgba(16,134,108,0.06)]"
                                }`}
                            >
                                {featured && (
                                    <div
                                        aria-hidden="true"
                                        className="absolute inset-0 pattern-star-gold opacity-[0.05]"
                                    />
                                )}
                                <span
                                    aria-hidden="true"
                                    className={`md:col-span-3 font-serif font-bold text-6xl sm:text-7xl leading-none ${
                                        featured ? "text-bh-gold" : "text-bh-green/60"
                                    }`}
                                >
                                    {program.number}
                                </span>
                                <div className="md:col-span-9 relative">
                                    <p
                                        className={`text-xs font-semibold uppercase tracking-[0.3em] mb-3 ${
                                            featured ? "text-bh-softgold" : "text-bh-gold"
                                        }`}
                                    >
                                        Program {program.number} — {program.label}
                                    </p>
                                    <h3
                                        className={`font-serif font-bold text-2xl sm:text-3xl tracking-tight mb-4 ${
                                            featured ? "text-white" : "text-bh-deep"
                                        }`}
                                    >
                                        {program.title}
                                    </h3>
                                    <p
                                        className={`text-base leading-relaxed ${
                                            featured ? "text-white/80" : "text-bh-gray"
                                        }`}
                                    >
                                        {program.description}
                                    </p>
                                    {program.method && (
                                        <p className="mt-5 inline-block rounded-full bg-bh-gold/15 border border-bh-gold/40 px-5 py-2 text-sm font-semibold text-bh-softgold">
                                            {program.method}
                                        </p>
                                    )}
                                    {program.target && (
                                        <p className="mt-4 text-sm leading-relaxed text-white/65 italic">
                                            {program.target}
                                        </p>
                                    )}
                                </div>
                            </article>
                        </Reveal>
                    );
                })}
            </div>
        </div>
    </section>
);
